import GridContainer from "@insite/mobius/GridContainer";
import GridItem from "@insite/mobius/GridItem";
import Page from "@insite/mobius/Page";
import PageBreadcrumbs from "@ucs/Overrides/Components/PageBreadcrumbs";
import * as React from "react";
import { ReactNode } from "react";

interface PageLayoutProps {
    showHeader: boolean;
    header: ReactNode;
    showCompactHeader: boolean;
    compactHeader: ReactNode;
    showBreadcrumbs: boolean;
    pageContent: ReactNode;
    showFooter: boolean;
    footer: ReactNode;
}

// This doesn't currently support HMR
const PageLayout = ({
    showHeader,
    header,
    showBreadcrumbs,
    pageContent,
    showFooter,
    footer,
    showCompactHeader,
    compactHeader,
}: PageLayoutProps) => {
    return (
        <>
            {showHeader && header}
            {showCompactHeader && compactHeader}
            {showBreadcrumbs && (
                <Page as="div">
                    <GridContainer style={{ paddingLeft: 6 }}>
                        <GridItem width={12}>
                            <PageBreadcrumbs />
                        </GridItem>
                    </GridContainer>
                </Page>
            )}
            {pageContent}
            {showFooter && footer}
        </>
    );
};

export default PageLayout;
